import { CustomerTrades } from '@src/containers/Blotters/CustomerTrades';
import type { CustomerTradesBlotterPanelConfig } from '@src/types/LayoutConfig';
import { MixpanelEventSource, MixpanelSourceProvider } from '@talos/kyoko';
import type { LayoutPanelProps } from '../../../types';
import { BlotterPanel } from './BlotterPanel';

export function CustomerTradesPanel({ params, api }: LayoutPanelProps<CustomerTradesBlotterPanelConfig>) {
  return (
    <MixpanelSourceProvider value={MixpanelEventSource.CustomerTradesBlotter}>
      <BlotterPanel
        panelApi={api}
        panelTabs={params.tabs}
        panelBlottersState={params.blotterTablesState}
        data-testid="customer-trades-blotter-panel"
      >
        <CustomerTrades />
      </BlotterPanel>
    </MixpanelSourceProvider>
  );
}
